import api from "..";
import Env from '../../config/environments';
import { ApiEndpoint, Method } from "../../constants";

const params = {};
const body = {};
export const getTeacherSubjectSubscription = (teacherId ) => {
    return api(`${ApiEndpoint.TEACHER_SUBCRIPTION}/teacher/${teacherId}`, Method.GET, params, Env.BASE_URL, body);
};

export const teacherSubcribeToSubject = (teacherId, subjectId, nameTagId) => {

    return api(`${ApiEndpoint.TEACHER_SUBCRIPTION}/subscribe/teacher/${teacherId}/subject/${subjectId}/nameTag/${nameTagId}`, Method.POST, params, Env.BASE_URL, body)
}

export const unsubscribeTeacherSubject = (teacherId, subjectId) => {
    return api(`${ApiEndpoint.TEACHER_SUBCRIPTION}/teacher/${teacherId}/subject/${subjectId}`, Method.DELETE, params, Env.BASE_URL, body)
}
